const handleNotifyPopup = () => {
  $(document).on('click', '.js-modal-notify', function(event) {
    const $this = $(this);
    const $masterSelect = $('#single-product-select');
    const $currentVariant = $masterSelect.find('option:selected');
    const variantImageSrc = $currentVariant.data('image-src');
    const $targetModal = $($this.attr('href'));
    const imageTemplate = `<img src="${variantImageSrc}">`;

    $targetModal.find('.modal__image').html(imageTemplate);

    event.preventDefault();
  });
}

handleNotifyPopup();
